import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import controllers from app/javascript/controllers
import DropdownController from "@controllers/dropdown_controller"
import SliderController from "@controllers/slider_controller"
import ToggleController from "@controllers/toggle_controller"
import BrainChatSettingsController from "@controllers/brain_chat_settings_controller"
import TooltipController from "@controllers/tooltip_controller"
import TagController from "@controllers/tag_controller"
import DatePickerController from "@controllers/date_picker_controller"
import CalendarController from "@controllers/calendar_controller"
import ModalController from "@controllers/modal_controller"
import SelectCardController from "@controllers/select_card_controller"
import TextareaController from "@controllers/textarea_controller"
import InloopPhasesController from "@controllers/inloop_phases_controller"
import SidebarController from "@controllers/sidebar_controller"
import TabsController from "@controllers/tabs_controller"
import ActivityDragDropController from "@controllers/activity_drag_drop_controller"
import TagInputController from "@controllers/tag_input_controller"
import GuidelineGeneratorController from "@controllers/guideline_generator_controller"
import ParticipantsController from "@controllers/participants_controller"
import RemindModalController from "@controllers/remind_modal_controller"
import OutcomesController from "@controllers/outcomes_controller"
import ParticipantBrainChatController from "@controllers/participant_brain_chat_controller"
import OutcomesMapController from "@controllers/outcomes_map_controller"
import OutcomesViewToggleController from "@controllers/outcomes_view_toggle_controller"
import OutcomesMapToggleController from "@controllers/outcomes_map_toggle_controller"
import MarkmapController from "@controllers/markmap_controller"
import ModalSwitcherController from "@controllers/modal_switcher_controller"
import ConversationFeedbackController from "@controllers/conversation_feedback_controller"
import CollapsibleController from "@controllers/collapsible_controller"
import ActivityCollapseController from "@controllers/activity_collapse_controller"
import ActivityReorderController from "@controllers/activity_reorder_controller"
import KickoffOutcomesToggleController from "@controllers/kickoff_outcomes_toggle_controller"
import CallTranscriptController from "@controllers/call_transcript_controller"
import CallSpeakerController from "@controllers/call_speaker_controller"
import CallOutputController from "@controllers/call_output_controller"
import ConversationProgressSidebarController from "@controllers/conversation_progress_sidebar_controller"
import MobileParticipantSidebarController from "@controllers/mobile_participant_sidebar_controller"
import MobileDashboardSidebarController from "@controllers/mobile_dashboard_sidebar_controller"
import FileUploadController from "@controllers/file_upload_controller"
import ActivitySelectorController from "@controllers/activity_selector_controller"
import DocumentValidationController from "@controllers/document_validation_controller"
import DocumentGeneratorController from "@controllers/document_generator_controller"
import ActivityTemplateSidebarController from "@controllers/activity_template_sidebar_controller"
import ActivityLayoutController from "@controllers/activity_layout_controller"
import CustomTabsController from "@controllers/custom_tabs_controller"
import InsightModeRefreshController from "@controllers/insight_mode_refresh_controller"
import PresentModeController from "@controllers/present_mode_controller"
import HeaderPresentModeController from "@controllers/header_present_mode_controller"
import ConversationChatController from "@controllers/conversation_chat_controller"
import ConversationSeedEditorController from "@controllers/conversation_seed_editor_controller"
import MessageFormController from "@controllers/message_form_controller"
import CommentsSidebarController from "@controllers/comments_sidebar_controller"
import CommentController from "@controllers/comment_controller"
import ActivityStatusSelectController from "@controllers/activity_status_select_controller"
import AiRoleSelectorController from "@controllers/ai_role_selector_controller"
import ActivityFormController from "@controllers/activity_form_controller"
import SettingsFormController from "@controllers/settings_form_controller"
import SettingsTabsController from "@controllers/settings_tabs_controller"
import ChangePasswordFormController from "@controllers/change_password_form_controller"
import ToastController from "@controllers/toast_controller"
import FacilitatorInloopController from "@controllers/facilitator_inloop_controller"
import ActivityParticipantsController from "@controllers/activity_participants_controller"
import ActivityConfigurationController from "@controllers/activity_configuration_controller"
import TagInputGuidelineController from "@controllers/tag_input_guideline_controller"
import FacilitatorActivityController from "@controllers/facilitator_activity_controller"
import GuidelineEditorController from "@controllers/guideline_editor_controller"
import AddPersonaController from "@controllers/add_persona_controller"
import AddSectionController from "@controllers/add_section_controller"
import ClipboardController from "@controllers/clipboard_controller"
import InloopParticipantsController from "@controllers/inloop_participants_controller"
import SendEmailController from "@controllers/send_email_controller"
import ActivityOutcomesController from "@controllers/activity_outcomes_controller"
import AutoSaveController from "@controllers/auto_save_controller"
import EmailInvitationController from "@controllers/email_invitation_controller"
import ConversationMonitorController from "@controllers/conversation_monitor_controller"
import FacilitatorConversationController from "@controllers/facilitator_conversation_controller"
import MessageEditController from "@controllers/message_edit_controller"
import InsightsSidebarController from "@controllers/insights_sidebar_controller"
import SidebarSyncController from "@controllers/sidebar_sync_controller"
import QrToggleController from "@controllers/qr_toggle_controller"
import ParticipantsToggleController from "@controllers/participants_toggle_controller"
import InsightsGeneratorController from "@controllers/insights_generator_controller"
import IndividualInsightsGeneratorController from "@controllers/individual_insights_generator_controller"
import ArtifactGeneratorController from "@controllers/artifact_generator_controller"
import TestInsightsGeneratorController from "@controllers/test_insights_generator_controller"
import DeleteModalController from "@controllers/delete_modal_controller"
import AddPhaseFormController from "@controllers/add_phase_form_controller"
import ActivityMapController from "@controllers/activity_map_controller"
import DeleteAccountController from "@controllers/delete_account_controller"
import SelectController from "@controllers/select_controller"
import InloopSearchController from "@controllers/inloop_search_controller"
import WebmcpController from "@controllers/webmcp_controller"
import SharedInloopsAutoloadController from "@controllers/shared_inloops_autoload_controller"
import AdminMobileMenuController from "@controllers/admin_mobile_menu_controller"
import PdfExportController from "@controllers/pdf_export_controller"
import ParticipantTreeController from "@controllers/participant_tree_controller"
import EditablePersonaController from "@controllers/editable_persona_controller"
import ConversationPdfExportController from "@controllers/conversation_pdf_export_controller"
import DocumentVersionSelectorController from "@controllers/document_version_selector_controller"
import CollapseController from "@controllers/collapse_controller"
import JobChartController from "@controllers/job_chart_controller"
import SpeechToTextController from "@controllers/speech_to_text_controller"
import TimezoneDetectorController from "@controllers/timezone_detector_controller"
import StreamingProgressController from "@controllers/streaming_progress_controller"
import RunwayIframeController from "@controllers/runway_iframe_controller"
import ColorSyncController from "@controllers/color_sync_controller"
import ConfirmDeleteController from "@controllers/confirm_delete_controller"
import FormBuilderController from "@controllers/form_builder_controller"
import FormRendererController from "@controllers/form_renderer_controller"
import FormResponsesController from "@controllers/form_responses_controller"
import FormOutcomesController from "@controllers/form_outcomes_controller"
import PollResultsController from "@controllers/poll_results_controller"
import ActivityCatalogController from "@controllers/activity_catalog_controller"
import CatalogFormBuilderController from "@controllers/catalog_form_builder_controller"
import CatalogTagsController from "@controllers/catalog_tags_controller"
import AiAnalyticOutputController from "@controllers/ai_analytic_output_controller"
import AiAnalyticConfigController from "@controllers/ai_analytic_config_controller"
import LlmProviderFormController from "@controllers/llm_provider_form_controller"
import AnalysisShareController from "@controllers/analysis_share_controller"
import EndSessionProgressController from "@controllers/end_session_progress_controller"
import SupervisorFlagsController from "@controllers/supervisor_flags_controller"
import ShortcutThumbnailController from "@controllers/shortcut_thumbnail_controller"

// Register controllers
application.register("dropdown", DropdownController)
application.register("slider", SliderController)
application.register("toggle", ToggleController)
application.register("brain-chat-settings", BrainChatSettingsController)
application.register("tooltip", TooltipController)
application.register("tag", TagController)
application.register("date-picker", DatePickerController)
application.register("calendar", CalendarController)
application.register("modal", ModalController)
application.register("select-card", SelectCardController)
application.register("textarea", TextareaController)
application.register("inloop-phases", InloopPhasesController)
application.register("sidebar", SidebarController)
application.register("tabs", TabsController)
application.register("activity-drag-drop", ActivityDragDropController)
application.register("tag-input", TagInputController)
application.register("guideline-generator", GuidelineGeneratorController)
application.register("participants", ParticipantsController)
application.register("remind-modal", RemindModalController)
application.register("outcomes", OutcomesController)
application.register("participant-brain-chat", ParticipantBrainChatController)
application.register("outcomes-map", OutcomesMapController)
application.register("outcomes-view-toggle", OutcomesViewToggleController)
application.register("outcomes-map-toggle", OutcomesMapToggleController)
application.register("markmap", MarkmapController)
application.register("modal-switcher", ModalSwitcherController)
application.register("conversation-feedback", ConversationFeedbackController)
application.register("collapsible", CollapsibleController)
application.register("activity-collapse", ActivityCollapseController)
application.register("activity-reorder", ActivityReorderController)
application.register("kickoff-outcomes-toggle", KickoffOutcomesToggleController)
application.register("call-transcript", CallTranscriptController)
application.register("call-speaker", CallSpeakerController)
application.register("call-output", CallOutputController)
application.register("conversation-progress-sidebar", ConversationProgressSidebarController)
application.register("mobile-participant-sidebar", MobileParticipantSidebarController)
application.register("mobile-dashboard-sidebar", MobileDashboardSidebarController)
application.register("file-upload", FileUploadController)
application.register("activity-selector", ActivitySelectorController)
application.register("document-validation", DocumentValidationController)
application.register("document-generator", DocumentGeneratorController)
application.register("activity-template-sidebar", ActivityTemplateSidebarController)
application.register("activity-layout", ActivityLayoutController)
application.register("custom-tabs", CustomTabsController)
application.register("insight-mode-refresh", InsightModeRefreshController)
application.register("present-mode", PresentModeController)
application.register("header-present-mode", HeaderPresentModeController)
application.register("conversation-chat", ConversationChatController)
application.register("conversation-seed-editor", ConversationSeedEditorController)
application.register("message-form", MessageFormController)
application.register("comments-sidebar", CommentsSidebarController)
application.register("comment", CommentController)
application.register("activity-status-select", ActivityStatusSelectController)
application.register("ai-role-selector", AiRoleSelectorController)
application.register("activity-form", ActivityFormController)
application.register("settings-form", SettingsFormController)
application.register("settings-tabs", SettingsTabsController)
application.register("change-password-form", ChangePasswordFormController)
application.register("toast", ToastController)
application.register("facilitator-inloop", FacilitatorInloopController)
application.register("activity-participants", ActivityParticipantsController)
application.register("activity-configuration", ActivityConfigurationController)
application.register("tag-input-guideline", TagInputGuidelineController)
application.register("facilitator-activity", FacilitatorActivityController)
application.register("guideline-editor", GuidelineEditorController)
application.register("add-persona", AddPersonaController)
application.register("add-section", AddSectionController)
application.register("clipboard", ClipboardController)
application.register("inloop-participants", InloopParticipantsController)
application.register("send-email", SendEmailController)
application.register("activity-outcomes", ActivityOutcomesController)
application.register("auto-save", AutoSaveController)
application.register("email-invitation", EmailInvitationController)
application.register("conversation-monitor", ConversationMonitorController)
application.register("facilitator-conversation", FacilitatorConversationController)
application.register("message-edit", MessageEditController)
application.register("insights-sidebar", InsightsSidebarController)
application.register("sidebar-sync", SidebarSyncController)
application.register("qr-toggle", QrToggleController)
application.register("participants-toggle", ParticipantsToggleController)
application.register("insights-generator", InsightsGeneratorController)
application.register("individual-insights-generator", IndividualInsightsGeneratorController)
application.register("artifact-generator", ArtifactGeneratorController)
application.register("test-insights-generator", TestInsightsGeneratorController)
application.register("delete-modal", DeleteModalController)
application.register("add-phase-form", AddPhaseFormController)
application.register("activity-map", ActivityMapController)
application.register("delete-account", DeleteAccountController)
application.register("select", SelectController)
application.register("inloop-search", InloopSearchController)
application.register("webmcp", WebmcpController)
application.register("shared-inloops-autoload", SharedInloopsAutoloadController)
application.register("admin-mobile-menu", AdminMobileMenuController)
application.register("pdf-export", PdfExportController)
application.register("participant-tree", ParticipantTreeController)
application.register("editable-persona", EditablePersonaController)
application.register("conversation-pdf-export", ConversationPdfExportController)
application.register("document-version-selector", DocumentVersionSelectorController)
application.register("collapse", CollapseController)
application.register("job-chart", JobChartController)
application.register("speech-to-text", SpeechToTextController)
application.register("timezone-detector", TimezoneDetectorController)
application.register("streaming-progress", StreamingProgressController)
application.register("runway-iframe", RunwayIframeController)
application.register("color-sync", ColorSyncController)
application.register("confirm-delete", ConfirmDeleteController)
application.register("form-builder", FormBuilderController)
application.register("form-renderer", FormRendererController)
application.register("form-responses", FormResponsesController)
application.register("form-outcomes", FormOutcomesController)
application.register("poll-results", PollResultsController)
application.register("activity-catalog", ActivityCatalogController)
application.register("catalog-form-builder", CatalogFormBuilderController)
application.register("catalog-tags", CatalogTagsController)
application.register("ai-analytic-output", AiAnalyticOutputController)
application.register("ai-analytic-config", AiAnalyticConfigController)
application.register("llm-provider-form", LlmProviderFormController)
application.register("analysis-share", AnalysisShareController)
application.register("end-session-progress", EndSessionProgressController)
application.register("supervisor-flags", SupervisorFlagsController)
application.register("shortcut-thumbnail", ShortcutThumbnailController)

import ImportZoneController from "@controllers/import_zone_controller"
application.register("import-zone", ImportZoneController)

import CharCounterController from "@controllers/char_counter_controller"
application.register("char-counter", CharCounterController)

import FlipCardController from "@controllers/flip_card_controller"
application.register("flip-card", FlipCardController)

import MarkdownRenderController from "@controllers/markdown_render_controller"
application.register("markdown-render", MarkdownRenderController)

import MarkdownEditorController from "@controllers/markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import BlogPostFormController from "@controllers/blog_post_form_controller"
application.register("blog-post-form", BlogPostFormController)

import LlmActionsController from "@controllers/llm_actions_controller"
application.register("llm-actions", LlmActionsController)

import FormLoaderController from "@controllers/form_loader_controller"
application.register("form-loader", FormLoaderController)

import StudioConnectionPingController from "@controllers/studio_connection_ping_controller"
application.register("studio-connection-ping", StudioConnectionPingController)

import EstimateRateCardController from "@controllers/estimate_rate_card_controller"
application.register("estimate-rate-card", EstimateRateCardController)

import DeliveryFormController from "@controllers/delivery_form_controller"
application.register("delivery-form", DeliveryFormController)

import DiscountCodeFormController from "@controllers/discount_code_form_controller"
application.register("discount-code-form", DiscountCodeFormController)

export { application }

import RecoveryDialogController from "@controllers/recovery_dialog_controller"
application.register("recovery-dialog", RecoveryDialogController)

import FacilitatorTranslationController from "@controllers/facilitator_translation_controller"
application.register("facilitator-translation", FacilitatorTranslationController)

import GroupWorkshopController from "@controllers/group_workshop_controller"
application.register("group-workshop", GroupWorkshopController)
import GroupConversationController from "@controllers/group_conversation_controller"
application.register("group-conversation", GroupConversationController)
